module.exports = __webpack_public_path__ + "src/assets/img/m1.5102a800.jpg";